import home from "./home";
import aboutUs from "./about-us";
import contactUs from "./contact-us";
import golfGetawaysMasthead from "./golf-getaways-masthead";
import aboutCoursesMasthead from "./about-courses-masthead";
import footer from "./footer";
import navbar from "./navbar";
import checkout from "./checkout";

import helpCenter from "./help-center";
import faqs from "./faqs";
import cancellationPolicy from "./cancellation-policy";
import careers from "./careers";
import termsOfService from "./terms-of-service";
import privacyPolicy from "./privacy-policy";

// pageKey -> fallback blocks. Add an entry here alongside each new
// defaultContent/<page>.js file as later phases add more pages.
const DEFAULT_CONTENT = {
  home,
  "about-us": aboutUs,
  "contact-us": contactUs,
  "golf-getaways-masthead": golfGetawaysMasthead,
  "about-courses-masthead": aboutCoursesMasthead,
  footer,
  navbar,
  checkout,
  "help-center": helpCenter,
  faqs,
  "cancellation-policy": cancellationPolicy,
  careers,
  "terms-of-service": termsOfService,
  "privacy-policy": privacyPolicy,
};

export default DEFAULT_CONTENT;
